import styled from 'styled-components'

type StyledProps = {
  $expanded?: boolean
}

const StyledCoursePreviewContentModule = styled.div<StyledProps>`
  overflow: hidden;
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-bottom-width: 0;

  .module-btn {
    background-color: ${({ theme }) => theme.color.gray[100]};
    border-bottom: 1px solid ${({ theme }) => theme.color.gray[200]};
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    height: 55px;

    ${({ $expanded, theme }) =>
      !$expanded &&
      `
      border-bottom: none;
    `}

    .module-title-container {
      display: flex;
      align-items: center;

      .module-title {
        font-weight: 500;
        font-size: 15px;
        color: ${({ theme }) => theme.color.gray[800]};
        display: -webkit-box;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-align: left;
        -webkit-box-orient: vertical;
      }

      svg {
        height: 16px;
        width: 16px;
        margin-right: 10px;
        stroke-width: 3px;
        flex-shrink: 0;
        color: ${({ theme }) => theme.color.gray[700]};
      }
    }

    .module-lesson-count {
      font-size: 14px;
      color: ${({ theme }) => theme.color.gray[500]};
      margin-left: 16px;
      flex-shrink: 0;
    }
  }

  .module-lesson-list {
    padding: 20px;
    display: grid;
    gap: 16px;
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
    border-bottom-width: 1px;
  }

  &:first-child:last-child {
    border-radius: 8px;
  }
`

export default StyledCoursePreviewContentModule
